import { has } from 'lodash';

const findProduct = (state, productId) => {
  return state.sections
    .reduce((products, section) => [...products, ...section.products], [])
    .find((product) => product.productId === productId);
};

export const SET_HEADER_WISHLIST_DATA = (state, data) => {
  if (data && data.wishlist && state.data) {
    state.data.wishlist = data.wishlist;
    state.data.isWished = true;
  }
};

export const SET_WISHLIST = (state, wishlist) => {
  if (has(wishlist, 'idWishlist') || has(wishlist, 'productCount')) {
    for (const field in wishlist) {
      if (Object.hasOwn(wishlist, field)) {
        if (field === 'sections' && !Array.isArray(wishlist.sections)) {
          if (wishlist.productCount === 0) {
            state.sections = [];
          }
          continue;
        }
        state[field] = wishlist[field];
      }
    }
  }
};

export const SET_PRODUCT_COUNT = (state, productCount) => {
  state.productCount = productCount;
};

export const SET_SECTIONS = (state, sections) => {
  state.sections = { ...sections };
};

export const SET_PRODUCT_IN_WISHLIST = (state, { productId, inWishlist }) => {
  const product = findProduct(state, productId);

  if (product) {
    product.inWishlist = inWishlist;
    state.sections = [...state.sections];
  }
};

export const REMOVE_PRODUCT_FROM_SECTIONS = (state, productId) => {
  if (Array.isArray(state.sections)) {
    state.sections = state.sections
      .map((section) => ({
        ...section,
        products: section.products.filter((p) => p.productId !== productId),
      }))
      .filter((section) => section.products.length > 0);
  }
  if (Array.isArray(state.products)) {
    state.products = state.products.filter((p) => p.productId !== productId);
  }
};

export const ADD_PRODUCT_TO_SECTIONS = (state, product) => {
  const entry = { ...product, inWishlist: true };

  if (Array.isArray(state.sections)) {
    const alreadyIn = state.sections.some((s) =>
      s.products.some((p) => p.productId === product.productId)
    );
    if (alreadyIn) return;

    if (state.sections.length === 0) {
      state.sections = [{ vehicle: 'Weitere Artikel', products: [entry] }];
      return;
    }

    const lastIdx = state.sections.length - 1;
    state.sections = state.sections.map((section, i) =>
      i === lastIdx ? { ...section, products: [...section.products, entry] } : section
    );
  } else if (Array.isArray(state.products)) {
    if (!state.products.some((p) => p.productId === product.productId)) {
      state.products = [...state.products, entry];
    }
  } else {
    state.sections = [{ vehicle: '', products: [entry] }];
  }
};
